import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { getRestaurantSettings } from "../../../services/profile.services";
import { useDispatch } from "react-redux";
import { addRestData } from "../../../../../redux/slices/restSettings";
import { LOADER_TIMEOUT_TIME, SWAL_SETTINGS } from "../../../../../utils/Constants";
import { useFormik } from "formik";
import { updateArrivalTimeStatus } from "../../../services/tipStatus.service";
import { handleServerValidations } from "../../../../../utils/commonfunction";
import Swal from "sweetalert2";
import { Plus, Minus } from "lucide-react";

const TimeCard = ({ label, name, value, setFieldValue }) => {
  const step = 5;

  return (
    <div className="card shadow-sm rounded-4 mb-4">
      <div className="card-body d-flex justify-content-between align-items-center">
        <div>
          <h3 className="fw-bold mb-1">{label}</h3>
          <small className="text-muted">Time in minutes</small>
        </div>

        <div className="d-flex align-items-center gap-3">
          <button
            type="button"
            className="btn btn-primary text-white rounded-circle" style={{width:"50px", height:"50px"}}
            onClick={() => setFieldValue(name, Math.max(0, value - step))}
          >
            <Minus size={16} />
          </button>

          <div className="fw-bold fs-5 text-center" style={{ minWidth: 60 }}>
            {value || 0} min
          </div>

          <button
            type="button"
            className="btn btn-primary text-white rounded-circle" style={{width:"50px", height:"50px"}}
            onClick={() => setFieldValue(name, (value || 0) + step)}
          >
            <Plus size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

const ArrivalTime = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [settings, setSettings] = useState({});
  const [loader, setLoader] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    setLoader(true);
    getRestaurantSettings()
      .then((res) => {
        dispatch(addRestData(res.data));
        setSettings(res.data || {});
        setTimeout(() => setLoader(false), LOADER_TIMEOUT_TIME);
      })
      .catch(() => setTimeout(() => setLoader(false), LOADER_TIMEOUT_TIME));
  }, [refresh]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      delivery_time: settings.delivery_time || 0,
      estimation_time: settings.estimation_time || 0,
    },
    onSubmit: (values) => {
      setSubmitLoader(true);

      updateArrivalTimeStatus(values)
        .then((res) => {
          setSubmitLoader(false);
          if (res.success) {
            Swal.fire({ icon: "success", text: res.message, ...SWAL_SETTINGS });
            setRefresh(!refresh);
          } else {
            Swal.fire({ icon: "error", text: handleServerValidations(res), ...SWAL_SETTINGS });
          }
        })
        .catch(() => setSubmitLoader(false));
    },
  });

  return (
    <main id="main-content">
      <div className="inner-container">
        <div className="page-header mb-4">
          <h3 className="heading-title-text mb-4">Time Settings</h3>
          <p className="text-muted mb-0">{t("restaurant.arrivalTime.config")}</p>
        </div>

        <div className="dashboard-content-wraper">
          <div className="row">
            <div className="col-md-12 col-lg-10 col-sm-12">
              {loader ? (
                <Skeleton height={120} count={3} />
              ) : (
                <form onSubmit={formik.handleSubmit}>

                  <TimeCard
                    label="Delivery Time"
                    name="delivery_time"
                    value={formik.values.delivery_time}
                    setFieldValue={formik.setFieldValue}
                  />

                  <TimeCard
                    label="Estimation Time"
                    name="estimation_time"
                    value={formik.values.estimation_time}
                    setFieldValue={formik.setFieldValue}
                  />

                  <button
                    type="submit"
                    className={`btn btn-primary px-5 ${submitLoader ? "btn-loader" : ""}`}
                  >
                    {t("restaurant.button.btn_update")}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>

      </div>
    </main>
  );
};

export default ArrivalTime;
